var viewer_caption_default = {
  "fontElementMap": "_5njXb",
  "imageCaption": "wCBOT"
};
export {
  viewer_caption_default as default
};
//# sourceMappingURL=viewer-caption-scss.js.map
